import { type ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@beatq/shared';
import { resolvePostLoginPath } from '../shell/postLoginReturn.js';

export function SignInReturnGate({ children }: { children: ReactNode }) {
  const { authenticated, bootstrapping } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const returnTo = resolvePostLoginPath(location.search, location.state, '/');

  useEffect(() => {
    if (bootstrapping || !authenticated) return;
    navigate(returnTo, { replace: true });
  }, [authenticated, bootstrapping, navigate, returnTo]);

  return children;
}
